"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.InnerRadioInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _excluded = ["input", "customClass", "meta", "inline", "label", "info", "id"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var baseClass = 'ap-radio';
var InnerRadioInput = exports.InnerRadioInput = function InnerRadioInput(props) {
  var input = props.input,
    customClass = props.customClass,
    meta = props.meta,
    inline = props.inline,
    label = props.label,
    info = props.info,
    id = props.id,
    passedProps = _objectWithoutProperties(props, _excluded);
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass, customClass]);
  delete passedProps.meta;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses(null, {
      inline: inline
    })
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    className: bemClasses('input'),
    type: "radio"
  }, input, passedProps, {
    id: id
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: bemClasses('label'),
    htmlFor: id
  }, label, /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('check')
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('checked')
  })), info && /*#__PURE__*/_react["default"].createElement("small", {
    className: "form-text-muted ".concat(bemClasses('radio-info'))
  }, info), meta.dirty && meta.error && /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('radio-error')
  }, meta.error));
};
var APRadio = function APRadio(props) {
  return /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, _extends({
    name: props.name,
    component: InnerRadioInput,
    type: "radio"
  }, props));
};
APRadio.defaultProps = {
  name: '',
  label: '',
  autoFocus: false,
  required: false,
  readOnly: false,
  inline: false,
  info: ''
};
APRadio.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  autoFocus: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  inline: _propTypes["default"].bool,
  info: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = APRadio;